<template>
  <div
    v-if="getTenantConfig(contact.contactType.toLowerCase(),'show')"
    class="card"
  >
    <div class="card-header notification level">
      <h3 class="card-header-title">
        {{ $t('domains.contacts.'+contact.contactType.toLowerCase()) }}
      </h3>
      <div
        v-if="getTenantConfig(contact.contactType.toLowerCase(),'edit')"
        class="level-right"
      >
        <button
          class="button is-primary is-medium is-uppercase"
          @click="$root.$emit('show::custom::modal',{name:'form-modal', data: contact} )"
        >
          {{ $t('common.edit') }}
        </button>
      </div>
    </div>
    <div class="card-content">
      <p>{{ completeName }}</p>
      <p>{{ contact.companyName }}</p>
      <p>{{ contact.addressLine1 }}</p>
      <p>{{ contact.addressLine2 }}</p>
      <p>{{ completeCity }}</p>
      <p>{{ completeCountry }}</p>
      <p>{{ contact.telephoneNumber }}</p>
      <p>{{ contact.emailAddress }}</p>
    </div>
  </div>
</template>

<script>
import tenantConfigwMixin from '@/mixins/tenant-config'

export default {
  name: 'AddressCard',
  mixins: [
    tenantConfigwMixin
  ],
  props: {
    contact: {
      type: Object,
      default () {
        return {
          firstName: '',
          lastName: '',
          title: '',
          addressLine1: '',
          addressLine2: '',
          emailAddress: '',
          companyName: '',
          telephoneNumber: '',
          faxNumber: '',
          postalCode: '',
          city: '',
          state: '',
          province: '',
          countryCode: '',
          contactType: '',
          companyPositionHeld: ''
        }
      }
    }
  },
  data () {
    return {
      excludeList: ['Billing']
    }
  },
  computed: {
    completeName () {
      if (this.contact.title.lenght > 0) {
        return this.contact.title + ' ' + this.contact.firstName + ' ' + this.contact.lastName
      } else {
        return this.contact.firstName + ' ' + this.contact.lastName
      }
    },
    completeCity () {
      let completeCity = ''

      if (this.contact.city && this.contact.city.lenght > 0) {
        completeCity = this.contact.city

        if (this.contact.postalCode && this.contact.postalCode.lenght > 0) {
          completeCity += ', ' + this.contact.postalCode
        }
      } else {
        if (this.contact.postalCode && this.contact.postalCode.lenght > 0) {
          completeCity = this.contact.postalCode
        }
      }
      return completeCity
    },
    completeCountry () {
      let complete = ''

      if (this.contact.province && this.contact.province.lenght > 0) {
        complete = this.contact.province

        if (this.contact.countryCode && this.contact.country.lenght > 0) {
          complete += ', ' + this.contact.countryCode
        }
      } else {
        if (this.contact.countryCode && this.contact.countryCode.lenght > 0) {
          complete = this.contact.country
        }
      }
      return complete
    }
  }
}

</script>

<style lang="scss" scoped>
  .card {
    .card-content {
      color: black;
    }
  }
  .card-header {
    background-color: var(--form-color-light);

  }
</style>
